export function buildBrowseUserPath(userId, username) {
  const normalizedUsername = String(username || "").trim();

  if (normalizedUsername) {
    return `/browse/users/${encodeURIComponent(normalizedUsername)}`;
  }

  const numericUserId = Number(userId);

  if (Number.isInteger(numericUserId) && numericUserId > 0) {
    return `/browse/users/${numericUserId}`;
  }

  return "/browse/users";
}